"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const borders = {
    "widthNone": "0",
    "widthXs": "calc(0.1rem * var(--voca-rem-multiplier))",
    "widthSm": "calc(0.2rem * var(--voca-rem-multiplier))",
    "widthMd": "calc(0.3rem * var(--voca-rem-multiplier))",
    "radiusNone": "0",
    "radiusSm": "calc(0.8rem * var(--voca-rem-multiplier))",
    "radiusLg": "calc(1.6rem * var(--voca-rem-multiplier))",
    "radiusDefault": "calc(0.2rem * var(--voca-rem-multiplier))",
    "radiusFull": "calc(99.9rem * var(--voca-rem-multiplier))",
    "all": "border",
    "top": "border-top",
    "right": "border-right",
    "bottom": "border-bottom",
    "left": "border-left"
};
exports.default = borders;
